export default "__VITE_ASSET__DeYCU5em__"